import { render, staticRenderFns } from "./LeftTabsLayout.vue?vue&type=template&id=bc2abbe6&scoped=true&"
import script from "./LeftTabsLayout.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LeftTabsLayout.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LeftTabsLayout.vue?vue&type=style&index=0&id=bc2abbe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2abbe6",
  null
  
)

export default component.exports